export default "/images/a5e2b825258e203e9bec01f879e5e64d.avif";